<template>
  <div class="d-flex pt-10">
    <div class="flex-1 d-flex justify-center">
      <div>
        <v-card width="400px" tile>
          <v-card-title> DTH </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="isValid">
              <v-text-field
                v-model="form.phone"
                outlined
                :rules="rules.phone"
                dense
                label="Enter Customer Number"
              ></v-text-field>
              <autocomplete
                v-model="form.provider"
                :items="items"
              ></autocomplete>
              <v-text-field
                v-model="form.amount"
                outlined
                dense
                :rules="rules.amount"
                label="Amount"
              ></v-text-field>
            </v-form>
            <v-row class="mb-5">
              <v-col>
                <v-btn
                  tile
                  depressed
                  block
                  class="orange"
                  dark
                  @click="$refs.dth.init()"
                >
                  View Plan
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  tile
                  depressed
                  block
                  class="orange"
                  dark
                  @click="$refs.bill.init()"
                >
                  Customer Info
                </v-btn>
              </v-col>
            </v-row>
            <v-btn block class="primary" @click="submit" depressed tile>
              Recharge</v-btn
            >
          </v-card-text>
        </v-card>
      </div>
    </div>
    <commisions :type="type"></commisions>
    <get-commission ref="commission" @continue="doRecharge"></get-commission>
    <QRCode ref="qrcode" @close="onQRClose"></QRCode>
    <DTHPlan ref="dth"></DTHPlan>
    <bill-details ref="bill" type="dth"></bill-details>
  </div>
</template>

<script>
import { getProviders } from "../../assets/js/common";
import { FIELD } from "../../assets/js/rules";
import rechargeMixins from "../../assets/mixins/recharge.mixins";
import Autocomplete from "../Autocomplete.vue";
import BillDetails from "./components/BillDetails.vue";
import Commisions from "./components/Commissions.vue";
import DTHPlan from "./components/DTHPlan.vue";
import GetCommission from "./components/GetCommission.vue";
import QRCode from "./components/QRCode.vue";
export default {
  components: {
    Autocomplete,
    GetCommission,
    QRCode,
    Commisions,
    BillDetails,
    DTHPlan,
  },
  mixins: [rechargeMixins],
  data() {
    return {
      form: {
        amount: "",
        provider: {},
      },
      rules: {
        phone: FIELD,
        amount: FIELD,
      },
      type: "DTH",
      isValid: false,
    };
  },
  computed: {
    items() {
      return getProviders(this.providers.dth);
    },
  },
  methods: {
    submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      let { amount, provider, phone } = vm.form;
      vm.$refs.commission.init({ phone, amount, provider, type: vm.type });
    },
    doRecharge() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      let { amount, provider, phone } = vm.form;
      vm.$refs.qrcode.init({
        RechargeNumber: phone,
        Amount: amount,
        ServiceName: provider.name,
        RechargeType: vm.type,
        TransId: "NA",
        Circle: "ALL",
      });
    },
    onQRClose(status) {
      console.log("cloee", status);
      if (status) {
        this.$refs.form.reset();
      }
    },
    init() {
      const vm = this;
      let { amount, service } = vm.$route.query;
      vm.form.amount = amount;
      vm.form.provider = vm.items.find((item) => {
        console.log(item);
        return item.Service == service;
      });
      console.log(vm.form.provider);
    },
  },
  beforeMount() {
    this.init();
  },
};
</script>

<style>
</style>